<template>
  <div class="flex items-center">
    <div class="members-wrap flex-1 h-10">
      <CurrentModelMembers
        :members="members"
        :is-card-preview="true"
        class="card-view-members-wrap"
      />
    </div>
  </div>
</template>

<script>
import boardListCardMixin from '@/mixins/boardListCardMixin';
import CurrentModelMembers from '@/components/widgets/CurrentModelMembers';

export default {
  name: 'CardMembers',
  components: { CurrentModelMembers },
  mixins: [boardListCardMixin],
  props: {
    cardId: {
      type: String,
      required: true,
    },
    // eslint-disable-next-line vue/no-unused-properties
    listId: {
      // used in boardListCardMixin
      type: [String, Number],
      required: false,
      default: '',
    },
  },
  data() {
    return {
      hovering: false,
    };
  },
  computed: {
    members() {
      return this.card.members
        ? [...this.card.members].sort(
            (a, b) => a.assigned_date - b.assigned_date || a.user_id.localeCompare(b.user_id)
          )
        : this.card.members;
    },
    card() {
      return this.$store.getters.getCards[this.cardId] || {};
    },
    visible() {
      return true;
    },
  },
};
</script>
